import htmlIcon from '../assets/html.png';
import cssIcon from '../assets/css.png';
import jsIcon from '../assets/js.png';
import reactIcon from '../assets/react.png';
import reduxIcon from '../assets/redux.png';
import nodeIcon from '../assets/node.png';
import tsIcon from '../assets/ts.png';
import javaIcon from '../assets/java.png';
import mongoIcon from '../assets/mongo.png';
import springIcon from '../assets/springIcon.svg';
import expressIcon from '../assets/expressIcon.svg';
import gitIcon from '../assets/gitIcon.svg';
import awsIcon from '../assets/awsIcon.svg';
import rustIcon from '../assets/rustIcon.svg';
import postmanIcon from '../assets/postmanIcon.svg';

export const skillList = [
    {
        skillName: 'Java',
        skillUrl: javaIcon,
    },
    {
        skillName: 'Spring',
        skillUrl: springIcon,
    },
    {
        skillName: 'React',
        skillUrl: reactIcon,
    },
    {
        skillName: 'NodeJS',
        skillUrl: nodeIcon,
    },
    {
        skillName: 'Express',
        skillUrl: expressIcon
    },
    {
        skillName: 'MongoDB',
        skillUrl: mongoIcon,
    },
    {
        skillName: 'TypeScript',
        skillUrl: tsIcon,
    },
    {
        skillName: 'HTML',
        skillUrl: htmlIcon,
    },
    {
        skillName: 'CSS',
        skillUrl: cssIcon,
    },
    {
        skillName: 'JavaScript',
        skillUrl: jsIcon,
    },
    {
        skillName: 'Redux',
        skillUrl: reduxIcon,
    },
    {
        skillName: 'Git',
        skillUrl: gitIcon
    },
    {
        skillName: 'AWS',
        skillUrl: awsIcon
    },
    {
        skillName: 'Rust',
        skillUrl: rustIcon
    },
    {
        skillName: 'Postman',
        skillUrl: postmanIcon
    }
];
